import { render, staticRenderFns } from "./editordict.vue?vue&type=template&id=5e2537e8&"
import script from "./editordict.vue?vue&type=script&lang=js&"
export * from "./editordict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e2537e8')) {
      api.createRecord('5e2537e8', component.options)
    } else {
      api.reload('5e2537e8', component.options)
    }
    module.hot.accept("./editordict.vue?vue&type=template&id=5e2537e8&", function () {
      api.rerender('5e2537e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/dictionary/editordict.vue"
export default component.exports